import { useEffect, useRef, useCallback } from 'react';
import { useRecoilValue } from 'recoil';
import { userAtom } from '../../services/atoms/auth.atoms';

declare global {
    interface Window {
        zE?: any;
        zESettings?: any;
    }
}

interface ZendeskWidgetProps {
    position?: 'left' | 'right';
    color?: string;
    hideWhenOffline?: boolean;
}

const ZendeskWidget: React.FC<ZendeskWidgetProps> = ({
    position = 'right',
    color = '#1f73b7',
    hideWhenOffline = false
}) => {
    const user = useRecoilValue(userAtom);
    const widgetInitialized = useRef(false);

    const configureWidget = useCallback(() => {
        if (!window.zE) {
            console.log('Zendesk zE not available yet');
            return;
        }
        console.log('Configuring Zendesk widget...');

    }, [position, color, user.data]);

    useEffect(() => {
        if (widgetInitialized.current || document.getElementById('ze-snippet')) {
            console.log('Zendesk already initialized');
            if (window.zE) {
                configureWidget();
            }
            return;
        }

        console.log('Initializing Zendesk widget...');
        

        const script = document.createElement('script');
        script.id = 'ze-snippet';
        script.src = 'https://static.zdassets.com/ekr/snippet.js?key=253e1783-c039-4879-8a1c-96d873323f14';
        script.async = true;
        
        script.onload = () => {
            console.log('Zendesk script loaded');
            const checkZE = () => {
                if (window.zE) {
                    console.log('Zendesk zE available, configuring widget...');
                    configureWidget();
                    widgetInitialized.current = true;
                } else {
                    console.log('Waiting for Zendesk zE...');
                    setTimeout(checkZE, 100);
                }
            };
            checkZE();
        };

        script.onerror = (error) => {
            console.error('Failed to load Zendesk script:', error);
        };

        document.head.appendChild(script);

        return () => {
            console.log('Cleaning up Zendesk widget...');
            const existingScript = document.getElementById('ze-snippet');
            if (existingScript && existingScript.parentNode) {
                existingScript.parentNode.removeChild(existingScript);
            }
            
            const zendeskContainer = document.querySelector('iframe[title="Messenger"]');
            if (zendeskContainer && zendeskContainer.parentNode) {
                zendeskContainer.parentNode.removeChild(zendeskContainer);
            }
            
           
            widgetInitialized.current = false;
        };
    }, [position, color, hideWhenOffline, configureWidget]);

    useEffect(() => {
        if (window.zE && widgetInitialized.current && user.data) {
            configureWidget();
        }
    }, [user.data, configureWidget]);

    return null;
};

export default ZendeskWidget;